import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate from react-router-dom v6
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  TableContainer,
  Container,
  Typography,
  Paper,
  Button, // Import Button component for "Create" button
  Box, // Import Box for layout
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { fetchDataFromAPI, deleteData } from "../components/api.js"; // Assuming these API functions exist

const Pages = () => {
  const [pages, setPages] = useState([]); // Ensure pages is always initialized as an empty array
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // Use useNavigate hook for navigation

  const columns = [
    { header: "Title", accessor: "title" },
    { header: "Description", accessor: "description" },
    { header: "Type", accessor: "type" },
    { header: "Actions", accessor: "actions" },
  ];

  useEffect(() => {
    fetchPages();
  }, []);

  const fetchPages = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const { data } = await fetchDataFromAPI("/api/page", {}, token); // Fetch pages from API
      console.log("pages", data);
      // Check if the data is an array and update the state
      if (Array.isArray(data)) {
        setPages(data);
      } else {
        console.error("Data fetched is not an array:", data);
        setPages([]); // Ensure we don't try to map over non-array data
      }

      setLoading(false);
    } catch (err) {
      console.error("Error fetching pages:", err);
      setLoading(false);
    }
  };

  const handleEdit = (id) => {
    navigate(`/dashboard/edit-page/${id}`); // Use navigate instead of history.push for navigation
  };

  const handleDelete = async (id) => {
    try {
      await deleteData(`/api/page/${id}`);
      fetchPages(); // Refresh the pages after deletion
    } catch (err) {
      console.error("Error deleting page:", err);
    }
  };

  const handleCreate = () => {
    navigate("/dashboard/edit-page"); // Navigate to the create page (no id provided)
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Box
      style={{
        backgroundColor: "#F4F6F9", // Dashboard background
        minHeight: "100vh",
        padding: "20px",
        // position: "relative", // Make the container relative to position the button
      }}
    >
      {/* Create Button on the Right */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between", // Ensures space between the elements
          alignItems: "center",
          position: "relative", // Make the parent container relative to position the button
          marginBottom: "35px",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Playfair Display",
            fontWeight: "bold",
          }}
          style={{ color: "#333333" }}
        >
          Pages
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCreate}
          style={{
            position: "absolute", // Position button absolutely relative to the parent container
            top: "20px", // Distance from the top
            right: "20px", // Distance from the right
            backgroundColor: "#2E4053", // Dark blue color for button
            color: "#FFFFFF", // White text color
            marginBottom: "40px",
          }}
        >
          Create Page
        </Button>
      </Box>

      <TableContainer
        component={Paper}
        style={{
          backgroundColor: "#F4F6F9",
          borderRadius: "10px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell
                  key={col.accessor}
                  sx={{
                    fontWeight: "bold",
                    color: "#FFFFFF",

                    cursor: "pointer",
                    backgroundColor: "#2E4053",
                  }}
                >
                  {col.header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(pages) && pages.length > 0 ? (
              pages.map((page) => (
                <TableRow key={page.id}>
                  <TableCell>{page.title}</TableCell>
                  <TableCell>{page.description}</TableCell>
                  <TableCell>{page.type}</TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleEdit(page.id)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => handleDelete(page.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  sx={{ textAlign: "center", py: 5, color: "#888" }}
                >
                  <Typography variant="subtitle1">
                    No pages found. Click "Create New Page" to begin.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Pages;
